<template>
  <div>
    <div v-if="!disableSort" class="px-4 pt-6">
      <select-list
        v-model="statusFilter"
        :items="statusOptions"
        label="Deal Status"
        multiple
        hide-details
        class="d-inline-flex"
      />
    </div>

    <data-table
      :headers="tableHeaders"
      :items="deals"
      :route="{ name: 'deals.edit', params: ['id'] }"
      sort-by="id"
      sort-desc
      v-bind="$props"
      v-on="$listeners"
    >
      <template #item="{ item }">
        <td v-if="showPartner">{{ getPartnerNameBySlug(item.partner) }}</td>
        <td>{{ item.name }}</td>
        <td>{{ formattedOption('dealTypes', item.type) }}</td>
        <td>{{ item.countries.length }}</td>
        <td><base-chip :text="item.status.toUpperCase()" :color="getStatusColor({ value: item.status })" /></td>
        <td>{{ formatDate(item.start, { format: 'DDMMYYYY' }) }}</td>
        <td>
          <span v-if="item.end">{{ formatDate(item.end, { format: 'DDMMYYYY' }) }}</span>
          <span v-else class="font-italic">Open Ended</span>
        </td>
      </template>

      <template #actions="{ item }">
        <v-list-item :disabled="!isPermittedTo('read')" @click="onInteract('deal-view', item)">
          <v-list-item-title>
            <v-icon left small>remove_red_eye</v-icon>
            <span>View</span>
          </v-list-item-title>
        </v-list-item>
        <v-list-item :disabled="!isPermittedTo('update')" @click="onInteract('deal-renew', item)">
          <v-list-item-title>
            <v-icon left small>refresh</v-icon>
            <span>Renew</span>
          </v-list-item-title>
        </v-list-item>
        <v-list-item :disabled="!isPermittedTo('create')" @click="onInteract('deal-delete', item)">
          <v-list-item-title>
            <v-icon left small>delete</v-icon>
            <span>Delete</span>
          </v-list-item-title>
        </v-list-item>
      </template>
    </data-table>
  </div>
</template>

<script>
// Components
import { VDataTable } from 'vuetify/lib'
import BaseChip from '@/components/chips/base-chip'
import DataTable from '@/components/data-table'
import SelectList from '@/components/forms/select-list'
// Mixins
import PermissionsHandler from '@/mixins/permissions-handler'
// Helpers
import { mapGetters } from 'vuex'
import { formatDate } from '@/utils/date'
// Services
import { partners } from '@/services/offers'

export default {
  name: 'DealsTable',
  components: {
    BaseChip,
    DataTable,
    SelectList,
  },
  extends: VDataTable,
  mixins: [PermissionsHandler],
  props: {
    deals: {
      type: Array,
      default: () => [],
    },
    editable: {
      type: Boolean,
      default: false,
    },
    showPartner: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    partners: [],
    statusFilter: ['live'],
  }),
  computed: {
    ...mapGetters({
      formattedOption: 'options/formattedOption',
      getStatusOptions: 'deals/getStatusOptions',
      getStatusColor: 'deals/getStatusColor',
    }),
    statusOptions() {
      return this.getStatusOptions()
    },
    tableHeaders() {
      return [
        this.showPartner ? { text: 'Partner', value: 'partner' } : null,
        { text: 'Name', value: 'name' },
        { text: 'Type', value: 'type' },
        { text: 'Countries', value: 'countries' },
        { text: 'Status', value: 'status', filter: v => this.disableSort || this.statusFilter.includes(v) },
        { text: 'Start Date', value: 'start' },
        { text: 'End Date', value: 'end' },
        this.editable ? { value: 'actions' } : null,
      ].filter(Boolean)
    },
  },
  watch: {
    showPartner: {
      handler() {
        this.getPartners()
      },
      immediate: true,
    },
  },
  methods: {
    formatDate,
    async getPartners() {
      try {
        const { data } = await partners.getAllPartners({ compact: true })
        this.partners = data
      } catch (e) {}
    },
    getPartnerNameBySlug(slug) {
      return this.partners.find(partner => partner.slug === slug)?.name || slug
    },
    onInteract(type, deal) {
      this.$emit(type, deal)
    },
  },
}
</script>
